import React, { useState, useEffect } from "react";
import { Card, CardContent, Typography, Box, IconButton, Button } from "@mui/material";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import CloseIcon from "@mui/icons-material/Close";

// Un solo anuncio
export const Anuncio = ({ anuncio }) => {
    const mostrarHora = new Date(anuncio.mostrar);
    const ahora = new Date();
    const diffMs = ahora - mostrarHora;
    const activo = diffMs <= 30 * 60 * 1000; // menos de 30 minutos

    const [visible, setVisible] = useState(true);

    // Revisar si está oculto en localStorage
    useEffect(() => {
        const ocultados = JSON.parse(localStorage.getItem("anunciosOcultos") || "[]");
        if (ocultados.includes(anuncio.idAnuncio)) {
            setVisible(false);
        }
    }, [anuncio]);

    const handleOcultar = () => {
        const ocultados = JSON.parse(localStorage.getItem("anunciosOcultos") || "[]");
        if (!ocultados.includes(anuncio.idAnuncio)) {
            ocultados.push(anuncio.idAnuncio);
            localStorage.setItem("anunciosOcultos", JSON.stringify(ocultados));
        }
        setVisible(false);
    };

    if (!activo || !visible) return null;

    return (
        <Card className="ki-announcement-card">
            <IconButton
                size="small"
                onClick={handleOcultar}
                sx={{ position: "absolute", top: 8, right: 8 }}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
            <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <NotificationsActiveIcon color="warning" sx={{ mr: 1 }} />
                    <Typography variant="subtitle2" color="text.secondary">
                        {anuncio.nombreUsuario} • {mostrarHora.toLocaleString()}
                    </Typography>
                </Box>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                    {anuncio.mensaje}
                </Typography>
            </CardContent>
        </Card>
    );
};

// Lista de anuncios con botón restaurar
export const ListaAnuncios = ({ anuncios }) => {
    const [refresh, setRefresh] = useState(false);

    const handleRestaurar = () => {
        localStorage.removeItem("anunciosOcultos");
        setRefresh(!refresh); // forzar render
    };

    console.log(anuncios);
    
    return (
        <Box>
                <>

                    <Button
                        variant="outlined"
                        color="primary"
                        sx={{ mb: 2 }}
                        onClick={handleRestaurar}
                    >
                        Mostra anuncis ocults
                    </Button>

                    {anuncios.map(a => (
                        <Anuncio key={a.idAnuncio} anuncio={a} />
                    ))}
                </>

        </Box>
    );
};
